import React, { startTransition, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getCaseData } from "../../backend/DataManager";
import DateBar from "../../components/DateBar/DateBar";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Slider from "../../components/Slider/Slider";
import styles from "./Dashboard.module.css";

function Dashboard() {
  const { t } = useTranslation(["dashboard"]);

  const navigate = useNavigate();
  const handleButtonClick = async () => {
    const caseNumberInput = document.getElementById("case_number_input");
    const cardNumberInput = document.getElementById("card_number_input");
    const birthDateInput = document.getElementById("birth_date_input");

    if (!caseNumberInput || !cardNumberInput || !birthDateInput) {
      alert(t("msg_field_empty"));
      return;
    }

    const caseNumber = caseNumberInput.value.toUpperCase();
    const cardNumber = cardNumberInput.value;
    const birthDate = birthDateInput.value;

    if (caseNumber === "" || cardNumber === "" || birthDate === "") {
      alert(t("msg_field_empty"));
      return;
    }

    console.log("Case Number:", caseNumber);
    console.log("Card Number:", cardNumber);
    console.log("Birth Date:", birthDate);

    try {
      const caseData = await getCaseData(caseNumber);

      if (caseData.birthDate !== birthDate) {
        alert(t("msg_incorrect_info"));
        return;
      }

      console.log(caseData); // or do something else with the data
      startTransition(() => {
        navigate(`/case-details/${caseNumber}`, { state: { caseData } });
      });
    } catch (error) {
      console.error("Error fetching case data:", error);
      if (error.message === "Case not found") {
        alert(t("msg_incorrect_info"));
      } else {
        alert(t("msg_field_empty")); // or add a new translation key for general errors
      }
    }
  };

  const titleStyle = {
    fontSize: "1.1rem",
    fontWeight: "normal",
    marginBottom: "2rem",
  };

  const orStyle = {
    fontSize: "1.1rem",
    fontWeight: "normal",
    marginTop: "1rem",
  };

  const caseNumberPrefixes = [385, 414, 969, 826, 457, 898, 495, 233, 559, 242];
  const [startDate, setStartDate] = useState(new Date());
  return (
    <div>
      <DateBar />
      <Header />

      <div className={styles.content_container}>
        <div className={styles.attention_container}>
          <h1>{t("attention_title")}</h1>
          <p>{t("attention_message")}</p>
        </div>

        <h1 style={titleStyle}>{t("dashboard_title")}</h1>

        <div>
          <label>{t("dashboard_case_number")}</label>
          <div className={styles.case_number_container}>
            <div className={styles.prefixes_dropdown}>
              <select>
                {caseNumberPrefixes.map((prefix) => (
                  <option key={prefix} value={prefix}>
                    {prefix}
                  </option>
                ))}
              </select>
            </div>
            <input
              maxLength="15"
              id="case_number_input"
              className={styles.input_field}
              type="text"
              placeholder="__C_____"
            />
          </div>
        </div>

        <h1 style={orStyle}>{t("dashboard_or")}</h1>

        <div className={styles.card_number_container}>
          <label>{t("dashboard_card_number")}</label>
          <input
            maxLength="15"
            id="card_number_input"
            className={styles.input_field}
            type="text"
            placeholder="___________"
            required
          />
        </div>

        <div className={styles.calendar_and_result_container}>
          <div className={styles.date_container}>
            <label>{t("dashboard_birth_date")}</label>

            <div>
              <DatePicker
                id="birth_date_input"
                className={styles.date_picker}
                selected={startDate}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <img
            className={styles.calendar_icon}
            src="/assets/icons/calendar.png"
            alt="Calendar"
          />
          <button
            onClick={() => handleButtonClick()}
            className={styles.search_button}
          >
            {t("dashboard_search")}
          </button>
        </div>
      </div>

      <Slider />

      <Footer />
    </div>
  );
}

export default Dashboard;
